export default "__VITE_ASSET__B270fOy0__"